var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 145 137",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_832_26)" } }, [
        _c("path", {
          attrs: {
            d:
              "M72.4944 136.36C110.149 136.36 140.674 105.835 140.674 68.1799C140.674 30.5252 110.149 0 72.4944 0C34.8397 0 4.31451 30.5252 4.31451 68.1799C4.31451 105.835 34.8397 136.36 72.4944 136.36Z",
            fill: "#99CBDF",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M143.45 67.2005C145.52 68.3534 145.52 70.3368 143.45 71.4897L76.7824 109.993C74.7122 111.146 71.4272 111.146 69.357 109.993L1.61102 71.031C-0.459167 69.8782 -0.459167 67.8947 1.61102 66.7419L68.2785 28.2389C70.3487 27.086 73.6338 27.086 75.7039 28.2389L143.45 67.2005Z",
            fill: "#3398C0",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M143.835 71.2294C143.736 71.2914 143.636 71.3533 143.525 71.4153V71.4401C143.525 71.4401 143.475 71.4773 143.45 71.4897L76.8573 109.993C76.3243 110.303 75.7912 110.451 75.2458 110.6V110.625C75.2458 110.625 75.1962 110.637 75.1714 110.65V110.6C74.3285 110.836 73.3367 110.91 72.345 110.836C72.0971 110.823 71.8368 110.786 71.5889 110.737C71.5145 110.724 71.4525 110.712 71.3781 110.699C71.2542 110.675 71.1302 110.65 71.0186 110.613C70.436 110.464 69.903 110.253 69.4319 109.993V110.03C69.4319 110.03 69.3823 110.005 69.3575 109.993L1.61152 71.031C1.37599 70.9071 1.16525 70.7707 0.979305 70.622C0.756171 70.436 0.557829 70.2253 0.409073 70.0269C0.223128 69.7542 0.111561 69.4691 0.0867682 69.184V69.3823C0.0371828 69.2212 0.0123901 69.06 0.0123901 68.8989V76.9317C0.0123901 77.7746 0.545433 78.5432 1.54954 79.0763V79.0267V79.1506L69.3699 118.038C70.2129 118.497 71.279 118.807 72.3574 118.881C72.7541 118.918 73.1632 118.918 73.5723 118.881C73.6095 118.881 73.6591 118.881 73.6962 118.881C73.7458 118.881 73.8078 118.881 73.8574 118.869C74.3409 118.831 74.8119 118.757 75.2706 118.645C75.878 118.497 76.4234 118.335 76.8821 118.038V117.988L143.475 79.5349C144.033 79.2002 144.43 78.8035 144.69 78.3945C144.702 78.3697 144.715 78.3573 144.727 78.3325C144.752 78.2953 144.777 78.2581 144.789 78.2209C144.888 78.0474 144.963 77.8738 145 77.7003V69.3575C145 70.0145 144.603 70.6715 143.847 71.2418L143.835 71.2294Z",
            fill: "#005F84",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M93.7395 48.3085L55.9678 26.305C55.1373 25.8215 54.3811 25.7596 53.848 26.0571H53.8357L42.9393 32.466L85.4959 91.0759C85.4959 91.0759 95.8345 85.6378 96.0204 85.5014C96.4543 85.1791 96.7146 84.6089 96.7146 83.8279V53.2794C96.7146 51.4944 95.3882 49.263 93.7519 48.3085H93.7395Z",
            fill: "#292929",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M45.5073 68.3782L83.279 90.3817C84.9029 91.3239 86.2417 90.6421 86.2417 88.8694V59.6636C86.2417 57.8785 84.9153 55.6472 83.279 54.6927L45.5073 32.6892C43.8834 31.747 42.5446 32.4288 42.5446 34.2015V63.4073C42.5446 65.1924 43.871 67.4237 45.5073 68.3782V68.3782Z",
            fill: "white",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M84.6664 91.1875C84.1706 91.1875 83.6375 91.0263 83.0921 90.7164L45.3204 68.7129C43.5849 67.7088 42.1718 65.3287 42.1718 63.4321V34.2015C42.1718 33.2346 42.5312 32.5032 43.1635 32.1313C43.8453 31.747 44.7626 31.8338 45.6799 32.3668L83.4516 54.3703C85.1871 55.3744 86.6002 57.7545 86.6002 59.6512V88.857C86.6002 89.8239 86.2407 90.5553 85.6085 90.9271C85.3234 91.0883 85.0135 91.1627 84.6664 91.1627V91.1875ZM44.1304 32.6272C43.9072 32.6272 43.7213 32.6767 43.5477 32.7759C43.1387 33.0114 42.9279 33.5197 42.9279 34.2015V63.4073C42.9279 65.0436 44.1924 67.1758 45.7047 68.0559L83.4764 90.0594C84.1705 90.4561 84.8152 90.5429 85.249 90.2949C85.6581 90.0594 85.8688 89.5512 85.8688 88.8694V59.6636C85.8688 58.0273 84.6044 55.8951 83.0921 55.0149L45.3204 33.0114C44.8989 32.7635 44.4775 32.6396 44.1304 32.6396V32.6272Z",
            fill: "white",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M46.5995 40.7323L46.1376 41.5249L56.9767 47.841L57.4386 47.0484L46.5995 40.7323Z",
            fill: "#292929",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M46.6043 44.3523L46.1425 45.1448L56.9816 51.4609L57.4434 50.6684L46.6043 44.3523Z",
            fill: "#292929",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M46.6067 47.9784L46.1449 48.771L56.984 55.0871L57.4458 54.2945L46.6067 47.9784Z",
            fill: "#292929",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M46.597 51.5983L46.1352 52.3909L56.9743 58.707L57.4361 57.9144L46.597 51.5983Z",
            fill: "#292929",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M46.6114 55.2244L46.1495 56.017L56.9886 62.3331L57.4505 61.5406L46.6114 55.2244Z",
            fill: "#292929",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M46.6019 58.8566L46.14 59.6492L56.9792 65.9653L57.441 65.1728L46.6019 58.8566Z",
            fill: "#292929",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M46.6045 62.4829L46.1427 63.2755L56.9818 69.5916L57.4436 68.799L46.6045 62.4829Z",
            fill: "#292929",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M60.3579 60.2833C60.2091 53.5521 65.242 50.577 71.1799 53.8868C77.8367 57.5933 83.068 66.0104 83.2415 73.2623C83.4027 80.0307 78.3202 83.0182 72.3328 79.6712C65.6635 75.9399 60.519 67.6095 60.3579 60.2709V60.2833Z",
            fill: "#DDDDDD",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M67.2636 72.8532C69.1478 74.8738 70.9205 76.7209 72.9163 77.601C74.7262 78.3944 75.7675 77.4275 75.5319 75.2829C75.2964 73.1879 74.3295 71.0929 73.1766 68.998C72.8295 68.3781 72.4452 67.7707 71.9122 66.8906C74.9369 68.0806 77.7633 69.0475 80.8128 71.8987C80.664 69.3451 80.3169 66.8038 78.693 64.0518C77.5649 62.1552 75.8294 61.3246 74.4782 61.9073C72.8791 62.6014 72.2469 64.3989 71.7262 66.6798C70.3255 62.7502 68.8131 59.1181 68.8751 55.6347C66.9661 55.424 65.243 55.424 64.0777 56.5892C62.9992 57.6801 63.5942 60.1594 65.4289 62.3287C67.0528 64.2626 68.8255 65.403 70.623 66.3327C70.9205 66.4815 71.2056 66.6055 71.7386 66.8658C70.6106 69.3451 69.6685 71.8615 67.2512 72.8532H67.2636Z",
            fill: "#292929",
          },
        }),
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_832_26" } }, [
          _c("rect", {
            attrs: { width: "145", height: "136.36", fill: "white" },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }